import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { jwtDecode } from "jwt-decode";

import { useModalStore, weekDays } from "../../store/GlobalVarriables";
import useApi from "../../hooks/useApi";
import { useStatusModal } from "../../context/StatusModalContext";
import { getQueryParam } from "../../utils/helpers";

import DotsMenu from "../../Components/DotsMenu";
import ModalConfirmation from "../../Components/ModalConfirmation/ModalConfirmation";
import CustomButton from "../../Components/CustomButton";
import Loader from "../../Components/Loader";

import { ReactComponent as Single } from "../../static/images/single_schedule_icon.svg";
import { ReactComponent as Group } from "../../static/images/groupe_schedule_icon.svg";
import { ReactComponent as EmptyIcon } from "../../static/images/empty_schedules.svg";

import "./style.scss";

const ProviderGroups = () => {
  const { get, del, loading } = useApi();

  const [groupsSchedule, setGroupsSchedule] = useState([]);
  const [menuItemsParams, setMenuItemsParams] = useState({});

  const [invitationInputToggle, setInvitationInputToggle] = useModalStore("");

  const [confirmModalToggle, setConfirmModalToggle] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const { showStatusModal } = useStatusModal();
  const { t } = useTranslation();

  const menuItems = [
    {
      text: t("schedule_details"),
      disabled: false,
      onClick: () => {
        navigate(`/schedule/${menuItemsParams.scheduleId}`);
      },
    },
    {
      text: t("edit_schedule"),
      onClick: () => {
        navigate(`/schedule/edit/${menuItemsParams.scheduleId}`);
      },
    },
    {
      text: t("invite_customer"),
      disabled: menuItemsParams.availableSeats <= 0,
      onClick: () => {
        if (menuItemsParams.availableSeats <= 0) {
          return;
        }
        handleMenuActions("invite customer");
      },
    },
    {
      text: t("cancel_schedule"),
      onClick: () => {
        handleMenuActions("cancel schedule");
      },
    },
    {
      text: t("finance"),
      disabled: true,
    },
    {
      text: t("training_history"),
      onClick: () => {
        navigate("/history/byschedule");
      },
    },
  ];

  const showFeatureTooltip = Boolean(
    getQueryParam("showFeatureTooltip", location),
  );
  const isFirstTime = Boolean(getQueryParam("firstTime", location));
  useEffect(() => {
    if (showFeatureTooltip) {
      setMenuItemsParams({
        scheduleId: groupsSchedule[0]?.id,
        availableSeats: groupsSchedule[0]?.availableSeats,
        price: groupsSchedule[0]?.price,
        index: 0,
      });
      handleMenutoggle(0);
    } else {
      setMenuItemsParams({});
      handleMenutoggle(-1);
    }
  }, [showFeatureTooltip]);

  const fetchGroupSchedule = async () => {
    const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));
    const decodedToken = jwtDecode(ps10005000);

    try {
      const data = await get(
        `/BusinessAccount/${decodedToken.buid}/Schedules?oneTime=true&onlyWithSubscription=false`,
      );

      setGroupsSchedule(
        data.map((item) => ({
          ...item,
          showMenu: false,
        })),
      );
    } catch (err) {}
  };

  const handleMenutoggle = (index) => {
    setGroupsSchedule(
      groupsSchedule.map((item, i) =>
        i === index
          ? { ...item, showMenu: !item.showMenu }
          : { ...item, showMenu: false },
      ),
    );
  };

  const handleMenuActions = (identity) => {
    handleMenutoggle(menuItemsParams.index);
    if (identity === "cancel schedule") {
      setConfirmModalToggle("modal-confirm");
    } else {
      navigate(`/schedule/${menuItemsParams.scheduleId}`);
      setInvitationInputToggle("invite");
    }
  };

  const modalConfirmationBtn = async () => {
    try {
      const data = await del(`/Schedule/${menuItemsParams.scheduleId}/Cancel`);
      if (data) {
        showStatusModal("canceled successfully!");
      }
      fetchGroupSchedule();
    } catch (error) {
      console.error(error);
    }
  };

  const convertDate = (value) => {
    const date = new Date(value);

    const day = date.getDate();
    const month = date.getMonth() + 1;

    const monthName = t(`months.${month}`);

    const formattedDate = `${day} ${monthName}`;

    return formattedDate;
  };

  useEffect(() => {
    fetchGroupSchedule();
    setInvitationInputToggle("");
  }, []);

  return (
    <div className="groups-container">
      {loading && <Loader />}
      <ModalConfirmation
        modalText={t("cancel_schedule_confirmation_modal_text")}
        modalSubText={t("cancel_schedule_confirmation_modal_subText")}
        changeModal={setConfirmModalToggle}
        modalValue={confirmModalToggle}
        confirm={modalConfirmationBtn}
      />

      {groupsSchedule.length === 0 ? (
        <div className="empty-schedules-container">
          {isFirstTime && <h1>Welcome! Let’s Get You Started</h1>}

          <p>Create your first session and invite your clients to join!</p>

          <EmptyIcon />
          <>
            <CustomButton
              onClick={() => {
                navigate("/invite");
              }}
            >
              Set Up Now
            </CustomButton>
            <button
              type="button"
              onClick={() => {
                navigate("/sessions");
              }}
              className="skipBtn"
            >
              Skip
            </button>
          </>
        </div>
      ) : (
        <>
          <ul className={`groups-list-contaienr`}>
            <h3>{t("schedules_individual_group")}</h3>

            {groupsSchedule.map((item, index) => {
              return (
                <li className="groups-list-item" key={item.id}>
                  <div
                    className="groups-single-item"
                    onClick={() => {
                      navigate(`/schedule/${item.id}`);
                    }}
                  >
                    <div className="groups-item-content">
                      <div className="groups-item-member-icon">
                        {item.groupSchedule === true ? <Group /> : <Single />}
                      </div>
                      <div className="groups-item-name">
                        <span>{item.description}</span>

                        <div className="schedule-days">
                          {item.isOneTime ? (
                            <>
                              <span>{convertDate(item.effectiveFrom)}</span>
                            </>
                          ) : (
                            <>
                              {item.scheduleDays
                                .sort(
                                  (a, b) =>
                                    weekDays.indexOf(a.dayOfWeek) -
                                    weekDays.indexOf(b.dayOfWeek),
                                )
                                .map((day) => {
                                  return (
                                    <React.Fragment key={day.id}>
                                      <span>
                                        {t(
                                          day.dayOfWeek
                                            .slice(0, 2)
                                            .toLowerCase(),
                                        )}
                                      </span>
                                      <span className="schedule-days-comma">
                                        ,
                                      </span>
                                    </React.Fragment>
                                  );
                                })}
                            </>
                          )}
                        </div>
                      </div>
                      <div
                        className="groupe-item-icons"
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                      >
                        <div
                          className="groups-item-members"
                          // style={{
                          //   border:
                          //     item.maxMembers === item.availableSeats
                          //       ? "1.5px solid #c11313"
                          //       : item.availableSeats === 0
                          //         ? "1.5px solid black"
                          //         : "1.5px solid #b6c700",
                          // }}
                        >
                          <>
                            {item.hasPendingInvitations ? (
                              <>
                                <span>
                                  {item.maxMembers - item.availableSeats}
                                </span>
                                <span>/{item.maxMembers}</span>
                                <span className="has-panding-invitation">
                                  !
                                </span>
                              </>
                            ) : (
                              <>
                                <span>
                                  {item.maxMembers - item.availableSeats}
                                </span>
                                <span>/{item.maxMembers}</span>
                              </>
                            )}
                          </>
                        </div>
                        <div className="groups-item-menu">
                          <DotsMenu
                            menuItems={menuItems}
                            isMenuOpen={item.showMenu}
                            toggleMenu={() => {
                              setMenuItemsParams({
                                scheduleId: item.id,
                                availableSeats: item.availableSeats,
                                price: item.price,
                                index: index,
                              });
                              handleMenutoggle(index);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
          <div className="addBtn-container">
            <CustomButton
              fullWidth
              onClick={() => {
                navigate("/invite");
              }}
            >
              {t("create_new_chedule")}
            </CustomButton>
          </div>
        </>
      )}
    </div>
  );
};

export default ProviderGroups;
